import React, { useState } from "react";

import { Box, Grid, Tab, Tabs } from "@mui/material";

import ActionAppSettings from "../components/settings/action-settings";
import GroupAppSettings from "../components/settings/group-settings";
import PermissionAppSettings from "../components/settings/permission-settings";
import TabPanel from "../components/shared/tab-panel";
import mainStyles from "../styles";
import PermissionMatrix from "components/settings/permission-matrix";
import PermissionSettingsByAction from "components/settings/permission-settings-by-action";
import PermissionSettingsByUser from "components/settings/permission-settings-by-user";

const AppSettings: React.FC = () => {
  const classes = mainStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number
  ) => {
    setTabValue(newValue);
  };

  const tabs = [
    {
      label: "Permission Matrix",
      component: <PermissionMatrix />,
      enabled: true,
    },
    {
      label: "Permissions",
      component: <PermissionAppSettings />,
      enabled: true,
    },
    {
      label: "Permissions by Group",
      component: <PermissionSettingsByAction />,
      enabled: true,
    },
    {
      label: "Permissions by User",
      component: <PermissionSettingsByUser />,
      enabled: true,
    },
    {
      label: "Groups",
      component: <GroupAppSettings />,
      enabled: true,
    },
    {
      label: "Actions",
      component: <ActionAppSettings />,
      enabled: true,
    },
  ];

  return (
    <Grid container sx={classes.basicSpacing} spacing={1}>
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              {tabs.map((tab) => {
                if (tab.enabled) {
                  return <Tab label={tab.label} key={tab.label} />;
                }
                return undefined;
              })}
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {tabs.map((tab, index) => {
              return (
                <div key={tab.label}>
                  <TabPanel value={tabValue} index={index}>
                    {tab.component}
                  </TabPanel>
                </div>
              );
            })}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AppSettings;
